import { useEffect, useState } from 'react'

import { AccordionData } from 'components/faqSection/accordion/AccordionData'
import { CustomAccordion } from 'components/uikit/Accordion'

import { AccordionHeader } from '../../common/accordionHeader/AccordionHeader'

interface AccordionProps {
  activeItem: string
}

const Accordion = ({ activeItem }: AccordionProps) => {
  const [openIndex, setOpenIndex] = useState<number>(0)
  useEffect(() => {
    setOpenIndex(0)
  }, [activeItem])
  return (
    <div className="flex flex-col">
      {AccordionData[activeItem]?.map((subItem: any, subIndex: any) => (
        <CustomAccordion
          withDivider={true}
          key={`${activeItem}-${subIndex}`}
          expanded={openIndex === subIndex}
          onChange={() => setOpenIndex(subIndex)}
        >
          <AccordionHeader title={subItem.title} />
          <div className="text-14 leading-[22px] font-normal pb-6" dangerouslySetInnerHTML={{ __html: subItem.text }} />
        </CustomAccordion>
      ))}
    </div>
  )
}

export default Accordion
